module.exports = __webpack_public_path__ + "static/media/dotnetcore-logo.a9449927.png";